import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Input } from '../ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Label } from '../ui/label';
import { HOLIDAY_TYPES, COUNTRIES } from './bibliothequeConstants';

const BibliothequeFiltersCard = ({
  searchTerm, setSearchTerm,
  filterYear, setFilterYear,
  filterType, setFilterType,
  filterCountry, setFilterCountry,
  years,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("holidayCommon.filters.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div>
            <Label>{t("holidayCommon.filters.search")}</Label>
          <div className="relative">
            <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder={t("holidayCommon.filters.searchPlaceholder")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-9"
            />
          </div>
        </div>
          <div>
            <Label>{t("holidayCommon.fields.year")}</Label>
          <Select value={filterYear} onValueChange={setFilterYear}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
                <SelectItem value="all">{t("holidayCommon.filters.allYears")}</SelectItem>
              {years.map((year) => (
                <SelectItem key={year} value={year.toString()}>{year}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
          <div>
            <Label>{t("holidayCommon.fields.type")}</Label>
          <Select value={filterType} onValueChange={setFilterType}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
                <SelectItem value="all">{t("holidayCommon.filters.allTypes")}</SelectItem>
                {Object.keys(HOLIDAY_TYPES).map((value) => (
                  <SelectItem key={value} value={value}>{t(`holidayCommon.types.${value}`)}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
          <div>
            <Label>{t("holidayCommon.fields.country")}</Label>
          <Select value={filterCountry} onValueChange={setFilterCountry}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
                <SelectItem value="all">{t("holidayCommon.filters.allCountries")}</SelectItem>
              {COUNTRIES.map((country) => (
                <SelectItem key={country} value={country}>{country}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default BibliothequeFiltersCard;
